export const clearExtensionErrors = () => {
  // Подавляем ошибки от сторонних расширений кошельков
  const originalConsoleError = console.error;
  console.error = (...args: any[]) => {
    const errorMessage = args[0]?.message || args[0]?.toString() || "";

    // Игнорируем ошибки от расширений кошельков
    if (
      errorMessage.includes("Channel secret not available") ||
      errorMessage.includes("inpage.js") ||
      errorMessage.includes("Extension context invalidated")
    ) {
      return;
    }

    originalConsoleError.apply(console, args);
  };

  // Также перехватываем глобальные ошибки
  window.addEventListener("error", (event) => {
    if (event.message?.includes("Channel secret not available")) {
      event.preventDefault();
      event.stopPropagation();
    }
  });

  // И unhandled rejections
  window.addEventListener("unhandledrejection", (event) => {
    const reason = event.reason?.message || event.reason?.toString() || "";
    if (reason.includes("Channel secret not available")) {
      event.preventDefault();
      event.stopPropagation();
    }
  });
};
